import React from "react"
import { Row, Col } from "antd"
const ItemDataPage = () => {
	return (
		<div >
			<div >
				<span style={{ display: 'flex', justifyContent: 'center', color: '#000', fontSize: '42px', fontWeight: 'normal', paddingTop: '60px' }}>
					Enjoy your development management
				</span>
			</div>
			<div style={{ marginTop: '56px' }}>
				<Row style={{ display: 'flex', justifyContent: 'center', }}>
					<Col style={{ width: '324px', height: '330px', backgroundColor: 'white', borderRadius: '20px' }}>
						<div style={{ width: '270px', marginLeft: '139px', marginTop: '50px' }}>
							<img src={require('../../static/img/ic-home-feedback.png')}
								style={{ width: '52px', height: '52px', }} />
						</div>
						<div style={{ width: '270px', fontSize: '20px', marginLeft: '30px', marginTop: '19px', textAlign: 'center' }}>
							Feedback</div>
						<div style={{ color: '#040404', width: '250px', fontSize: '16px', marginLeft: '40px', marginTop: '16px', textAlign: 'center' }}>
							Developers can query user feedback and application logs of related applications to locate problems and learn about product defects
						</div>
					</Col>

					<Col style={{ width: '324px', height: '330px', backgroundColor: 'white', borderRadius: '20px' ,marginLeft: '30px'}}>
						<div style={{ width: '270px', marginLeft: '139px', marginTop: '50px' }}>
							<img src={require('../../static/img/ic-home-dashboard.png')}
								style={{ width: '52px', height: '52px', }} />
						</div>
						<div style={{ width: '270px', fontSize: '20px', marginLeft: '30px', marginTop: '19px', textAlign: 'center' }}>
							Dashboard</div>
						<div style={{ color: '#040404', width: '250px', fontSize: '16px', marginLeft: '40px', marginTop: '16px', textAlign: 'center' }}>
							Product managers, sales, and developers can easily view various types of data such as user usage and additions or payments
						</div>
					</Col>

					<Col style={{ width: '324px', height: '330px', backgroundColor: 'white', borderRadius: '20px' ,marginLeft: '30px'}}>
						<div style={{ width: '270px', marginLeft: '139px', marginTop: '50px' }}>
							<img src={require('../../static/img/ic-home-feature-flag.png')}
								style={{ width: '52px', height: '52px', }} />
						</div>
						<div style={{ width: '270px', fontSize: '20px', marginLeft: '30px', marginTop: '19px', textAlign: 'center' }}>
							Feature flag</div>
						<div style={{ color: '#040404', width: '250px', fontSize: '16px', marginLeft: '40px', marginTop: '16px', textAlign: 'center' }}>
							Through Feature Flag, developers can publish specific functions in Gray testing method or A/B Test, manage whitelist and  even customize specific open policies
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}


export default ItemDataPage
